import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, apiError } from "../lib/api";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [state, setState] = useState("working"); // working | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    (async () => {
      if (!token) { setState("error"); setMsg("This link is missing or invalid."); return; }
      try {
        await api.post("/account/email/confirm", { token });
        setState("ok");
      } catch (e) { setState("error"); setMsg(apiError(e)); }
    })();
  }, [token]);

  return (
    <div className="df-shell df-safe-top min-h-screen flex flex-col justify-center px-6">
      <div className="df-fade-in max-w-md mx-auto w-full">
        <div className="flex items-center gap-3 mb-8">
          <img src="/molaroo-mark.png" alt="Molaroo" className="h-14 w-14 rounded-2xl object-contain bg-white shadow-sm" />
          <div>
            <div className="text-2xl font-heading font-bold tracking-tight text-slate-900 leading-none">Molaroo</div>
            <div className="text-xs text-slate-400 mt-1">by NavScora</div>
          </div>
        </div>
        <div className="df-card p-6 text-center" data-testid="confirm-email-result">
          {state === "working" && <p className="text-slate-500">Confirming your new email…</p>}
          {state === "ok" && (<>
            <h1 className="text-xl font-bold text-slate-900 mb-1">Email updated</h1>
            <p className="text-slate-500 text-sm">Your account email has been changed. Please sign in with your new email.</p>
            <Link to="/login" className="inline-block mt-5 text-[#0D786A] font-semibold df-pressable">Go to sign in</Link>
          </>)}
          {state === "error" && (<>
            <h1 className="text-xl font-bold text-slate-900 mb-1">Couldn't confirm</h1>
            <p className="text-slate-500 text-sm">{msg}</p>
            <button onClick={() => navigate("/more/privacy")} className="inline-block mt-5 text-[#0D786A] font-semibold df-pressable">Back to Privacy &amp; Data</button>
          </>)}
        </div>
      </div>
    </div>
  );
}
